export class Endereco {
    id: number;
    uf: string;
    cep: string;
    cidade: string;
    bairro: string;
    complemento: string;
    numero: string;
    logradouro: string;
}